import Cookies from "js-cookie";

$(function() {

	const $bar = $('.m-cookiebar');
	const $onOff = $bar.find('.on-off');
	const $toggle = $('.m-cookiebar--toggle-settings');
	const $settings = $('.m-cookiebar--settings');
	const $btnSave = $('.m-cookiebar--save');
	const $btnAccept = $('.m-cookiebar--accept-all');
	const $buttons = $('.m-cookiebar--buttons');
	const $btnDeny = $('.m-cookiebar--deny-all'); // not currently used. do we need it?
	const $alert = $('.m-cookiebar--alert');

	$toggle.on('click', function () {
		$settings.slideDown(100);
		$toggle.hide();
		$btnSave.show();
	});

	$onOff.on('click', function() {
		// console.log(
		$(this).toggleClass('on');
		$buttons.slideDown() // buttons row might be hidden after save
	});

	$btnSave.on('click', function() {
		save();
	});

	$btnDeny.on('click', function() {
		$onOff.removeClass('on');
		save();
	});

	$btnAccept.on('click', function() {
		$onOff.addClass('on');
		save();
	});

	function gtag(){dataLayer.push(arguments)}

	function save() {
		const data = {};
		for (const key of ['analytics', 'ad', 'personalization']) {
			data[`${key}_storage`] = $('.m-cookiebar--set-' + key).hasClass('on') ? 'granted' : 'denied';
		}

		// delete cookies when disabled
		if (data['ad'] === 'denied') {
			$.ajax('/cookies/forget-cj');
		}

		const cookieData = JSON.stringify(data);

		Cookies.set('cookiebarConfig', cookieData, { expires: 365 });
		gtag('consent', 'update', data);
		dataLayer.push({'event': 'consent_updated'});

		if ($bar.hasClass('m-cookiebar-fixed')) {
			$bar.fadeOut(300, function () {
				$bar.remove()
			});
		} else {
			$alert.fadeIn();
			$buttons.slideUp();
		}
	}

	// init defaults
	const cookieData = Cookies.get('cookiebarConfig');
	try {
		const data = JSON.parse(cookieData);
		if (data) {
			for (const key of ['analytics', 'ad', 'personalization']) {
				if (data[`${key}_storage`] === 'granted') $('.m-cookiebar--set-' + key).addClass('on');
			}
		}
	} catch (e) {
		// malformed cookie data. keep all off
	}
});
